export default {
  methods: {
    isWeiXin () {
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.indexOf('micromessenger') !== -1) {
        return true
      } else {
        return false
      }
    },
    isMobile (param) {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    getRequest (key) {
      // 获取参数
      var url = window.location.search
      // 正则筛选地址栏
      var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')
      // 匹配目标参数
      var result = url.substr(1).match(reg)
      // 返回参数值
      return result ? decodeURIComponent(result[2]) : null
    },
    getChineseAndPoint (strValue) {
      // 匹配中文字符以及这些中文标点符号 。 ？ ！ ， 、 ； ： “ ” ‘ ' （ ） 《 》 〈 〉 【 】 『 』 「 」 ﹃ ﹄ 〔 〕 … — ～ ﹏ ￥
      var reg = /[\u4e00-\u9fa5|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/g
      var tempValue = strValue.match(reg) // 匹配结果，可能为空，还需要进行判断
      var resultStr = ''
      if (tempValue != null) {
        resultStr = tempValue.join('')
      }
      return resultStr // 返回匹配的字符串
    },
    getBrowserVersion () {
      var Sys = {}
      var ua = navigator.userAgent.toLowerCase()

      // Edge:    mozilla/5.0 (windows nt 10.0; win64; x64) applewebkit/537.36 (khtml, like gecko) chrome/52.0.2743.116 safari/537.36 edge/15.15063
      // IE11:    mozilla/5.0 (windows nt 10.0; wow64; trident/7.0; .net4.0c; .net4.0e; .net clr 2.0.50727; .net clr 3.0.30729; .net clr 3.5.30729; rv:11.0) like gecko
      // IE6:     mozilla/4.0 (compatible; msie 6.0; windows nt 5.1; sv1)
      // Safari:  mozilla/5.0 (windows nt 5.1) applewebkit/534.57.2 (khtml, like gecko) version/5.1.7 safari/534.57.2
      // Chrome:  mozilla/5.0 (windows nt 10.0; wow64) applewebkit/537.36 (khtml, like gecko) chrome/61.0.3163.79 safari/537.36
      // Firefox: mozilla/5.0 (windows nt 5.1; rv:52.0) gecko/20100101 firefox/52.0
      // Opera:   mozilla/5.0 (windows nt 10.0; win64; x64) applewebkit/537.36 (khtml, like gecko) chrome/60.0.3112.90 safari/537.36 opr/47.0.2631.80 (edition baidu)

      var s = null
      if ((s = ua.match(/msie ([\d.]+)/)) != null) {
        Sys.ie = s[1]
      }
      if ((s = ua.match(/edge\/([\d.]+)/)) != null) {
        Sys.edge = s[1]
      }
      if ((s = ua.match(/firefox\/([\d.]+)/)) != null) {
        Sys.firefox = s[1]
      }
      if ((Sys.edge == null) && ((s = ua.match(/chrome\/([\d.]+)/)) != null)) {
        Sys.chrome = s[1]
      }
      if ((s = ua.match(/opera.([\d.]+)/)) != null) {
        Sys.opera = s[1]
      }
      if ((s = ua.match(/opr\/([\d.]+)/)) != null) {
        Sys.opera = s[1]
        Sys.chrome = null
        Sys.safari = null
      }
      if ((s = ua.match(/version\/([\d.]+).*safari/)) != null) {
        Sys.safari = s[1]
      }
      if ((Sys.firefox == null) && (ua.match(/windows nt ([\d.]+)/) != null) && ((s = ua.match(/rv:([\d.]+)/)) != null)) {
        Sys.ie = s[1]
      }

      if (Sys.ie) {
        return ('IE: ' + Sys.ie)
      }
      if (Sys.firefox) {
        return ('Firefox: ' + Sys.firefox)
      }
      if (Sys.chrome) {
        return ('Chrome: ' + Sys.chrome)
      }
      if (Sys.opera) {
        return ('Opera: ' + Sys.opera)
      }
      if (Sys.safari) {
        return ('Safari: ' + Sys.safari)
      }
      if (Sys.edge) {
        return ('Edge: ' + Sys.edge)
      }

      return 'Unknow'
    },
    // 转换为英文日期格式：2021-01-28 14:57转换为Jan. 28th, 2021 14:57
    getEnglishDate (val) {
      if (val) {
        const monthEnglish = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Spt', 'Oct', 'Nov', 'Dec']
        let date = new Date(Date.parse(val.replace(/-/g, '/')))
        date = monthEnglish[date.getMonth()] + '. ' +
        this.prefixInteger(date.getDate()) + 'th, ' +
        date.getFullYear() + '  ' +
        this.prefixInteger(date.getHours()) + ':' +
        this.prefixInteger(date.getMinutes())
        return date
      }
      return ''
    },
    // 转换为英文日期格式：2021-01-22--2021-04-10转换为Jan. 22th, 2021--Apr. 10th, 2021
    getEnglishDate2 (val) {
      if (val) {
        const monthEnglish = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Spt', 'Oct', 'Nov', 'Dec']
        const lst = val.split('--')
        let start = new Date(Date.parse(lst[0].replace(/-/g, '/')))
        start = monthEnglish[start.getMonth()] + '. ' +
        this.prefixInteger(start.getDate()) + 'th, ' +
        start.getFullYear()
        let end = new Date(Date.parse(lst[1].replace(/-/g, '/')))
        end = monthEnglish[end.getMonth()] + '. ' +
        this.prefixInteger(end.getDate()) + 'th, ' +
        end.getFullYear()
        return start + '--' + end
      }
      return ''
    },
    expire (time) {
      if (time) {
        const endTime = new Date(Date.parse(time.replace(/-/g, '/')))
        const curTime = new Date()
        return endTime < curTime
      }
      return true
    },
    prefixInteger (val) {
      return ('0' + val).substr(-2)
    },
    strCode (str) {
      var count = 0
      if (str) {
        const len = str.length
        for (let i = 0; i < len; i++) {
          if (str.charCodeAt(i) > 255) { // 字符编码大于255，说明是双字节字符(即是中文)
            count += 2 // 则累加2个
          } else {
            count++ // 否则递加一次
          }
        }
        console.log(count)
        return count // 返回字节数
      } else {
        console.log(0)
        return 0 // 如果参数为空，则返回0个
      }
    }
  }
}
